function getCaretPosition(document, contentEditable) {
  var range = document.getSelection().getRangeAt(0);
  var sC = range.startContainer,
    eC = range.endContainer;
  var A = [];
  while (sC !== contentEditable) {
    A.push(getNodeIndex(sC));
    sC = sC.parentNode;
  }
  var B = [];
  while (eC !== contentEditable) {
    B.push(getNodeIndex(eC));
    eC = eC.parentNode;
  }

  return { sC: A, sO: range.startOffset, eC: B, eO: range.endOffset };
}

function restoreCaretPosition(
  document,
  contentEditable,
  rp,
  skipFocus = false,
) {
  if (!skipFocus) {
    contentEditable.focus();
  }
  var sel = document.getSelection(),
    range = sel.getRangeAt(0);
  var x,
    C,
    sC = contentEditable,
    eC = contentEditable;

  C = rp.sC;
  x = C.length;
  while (x--) {
    sC = sC.childNodes[C[x]];
  }
  C = rp.eC;
  x = C.length;
  while (x--) {
    eC = eC.childNodes[C[x]];
  }

  if (!sC || !eC) return;

  if (rp.sO === rp.eO) {
    range.setStart(sC, rp.sO);
    range.setEnd(sC, rp.sO);
  }
  eC.childNodes[C[x]];

  range.setStart(sC, rp.sO);
  range.setEnd(eC, rp.eO);
  sel.removeAllRanges();
  sel.addRange(range);
}

function getCaretPositionMultipleCE(
  document,
  contentEditableStart,
  contentEditableEnd,
) {
  var range = document.getSelection().getRangeAt(0);
  var sC = range.startContainer,
    eC = range.endContainer;
  var A = [];
  while (sC !== contentEditableStart) {
    A.push(getNodeIndex(sC));
    sC = sC.parentNode;
  }
  var B = [];
  while (eC !== contentEditableEnd) {
    B.push(getNodeIndex(eC));
    eC = eC.parentNode;
  }

  return { sC: A, sO: range.startOffset, eC: B, eO: range.endOffset };
}

function restoreCaretPositionMultipleCE(
  document,
  contentEditableStart,
  contentEditableEnd,
  rp,
  skipFocus = false,
) {
  // if(!skipFocus){
  //     contentEditable.focus();
  // }
  var sel = document.getSelection(),
    range = sel.getRangeAt(0);
  var x,
    C,
    sC = contentEditableStart,
    eC = contentEditableEnd;

  C = rp.sC;
  x = C.length;
  while (x--) {
    sC = sC.childNodes[C[x]];
  }
  C = rp.eC;
  x = C.length;
  while (x--) {
    eC = eC.childNodes[C[x]];
  }

  if (!sC || !eC) return;

  if (rp.sO === rp.eO) {
    range.setStart(sC, rp.sO);
    range.setEnd(sC, rp.sO);
  }
  eC.childNodes[C[x]];

  range.setStart(sC, rp.sO);
  range.setEnd(eC, rp.eO);
  sel.removeAllRanges();
  sel.addRange(range);
}

function getNodeIndex(n) {
  var i = 0;
  while ((n = n.previousSibling)) i++;
  return i;
}

function setEndOfTextNode(node, document) {
  if (!node) return;

  var range = document.createRange();
  var sel = window.getSelection();
  range.setStart(node, node.length);
  range.setEnd(node, node.length);
  sel.removeAllRanges();
  sel.addRange(range);
}

/**
 * Check if the caret is on the first line of an element
 * Returns `false` when the caret is part of a selection
 *
 * @param {Element} element
 * @return {boolean}
 */
function isCaretOnFirstLine(element) {
  // if (element.ownerDocument.activeElement !== element) return false;

  // Get the client rect of the current selection
  let window = element.ownerDocument.defaultView;
  let selection = window.getSelection();
  if (selection.rangeCount === 0) return false;

  let originalCaretRange = selection.getRangeAt(0);

  // Bail if there is text selected
  if (originalCaretRange.toString().length > 0) return false;

  let originalCaretRect = originalCaretRange.getBoundingClientRect();

  // Create a range at the end of the last text node
  let startOfElementRange = element.ownerDocument.createRange();
  startOfElementRange.selectNodeContents(element);

  // The endContainer might not be an actual text node,
  // try to find the last text node inside
  let startContainer = startOfElementRange.endContainer;
  let startOffset = 0;
  while (startContainer.hasChildNodes() && !(startContainer instanceof Text)) {
    startContainer = startContainer.firstChild;
  }

  startOfElementRange.setStart(startContainer, startOffset);
  startOfElementRange.setEnd(startContainer, startOffset);
  let endOfElementRect = startOfElementRange.getBoundingClientRect();
  return originalCaretRect.top === endOfElementRect.top;
}

/**
 * Check if the caret is on the last line of an element
 * Returns `false` when the caret is part of a selection
 *
 * @param {Element} element
 * @return {boolean}
 */
function isCaretOnLastLine(element) {
  // if (element.ownerDocument.activeElement !== element) return false;

  // Get the client rect of the current selection
  let window = element.ownerDocument.defaultView;
  let selection = window.getSelection();
  if (selection.rangeCount === 0) return false;

  let originalCaretRange = selection.getRangeAt(0);

  // Bail if there is a selection
  if (originalCaretRange.toString().length > 0) return false;

  let originalCaretRect = originalCaretRange.getBoundingClientRect();

  // Create a range at the end of the last text node
  let endOfElementRange = document.createRange();
  endOfElementRange.selectNodeContents(element);

  // The endContainer might not be an actual text node,
  // try to find the last text node inside
  let endContainer = endOfElementRange.endContainer;
  let endOffset = 0;
  while (endContainer.hasChildNodes() && !(endContainer instanceof Text)) {
    endContainer = endContainer.lastChild;
    endOffset = endContainer.length ?? 0;
  }

  endOfElementRange.setEnd(endContainer, endOffset);
  endOfElementRange.setStart(endContainer, endOffset);
  let endOfElementRect = endOfElementRange.getBoundingClientRect();

  return originalCaretRect.bottom === endOfElementRect.bottom;
}

export {
  getCaretPosition,
  restoreCaretPosition,
  getCaretPositionMultipleCE,
  restoreCaretPositionMultipleCE,
  isCaretOnFirstLine,
  isCaretOnLastLine,
  setEndOfTextNode,
};
